import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'

import { getCurrentOrganizationId } from '../../ducks/users'

import Header from '../Shared/Header'
import Info from './Info'
import Users from './Users'
import Billing from './Billing'
import InviteUser from './Users/Invite'

export default function Settings() {
  const organizationId = useSelector(getCurrentOrganizationId)

  return (
    <div>
      <Header>Company Settings</Header>
      <Info organizationId={organizationId} />
      <Users organizationId={organizationId} />
      <Billing organizationId={organizationId} />
      <Route path="/settings/invite" component={InviteUser} />
    </div>
  )
}
